export const formatUSD = (amount: number) =>
  `$${Number.parseFloat(amount.toFixed(2))}`;
